/** Formats monitoring `durationSeconds` for assignment tables. Null means the run has not started. */
export function formatAssignmentDuration(seconds?: number | null): string {
  if (seconds == null || !Number.isFinite(seconds)) {
    return '—';
  }
  const elapsed = Math.max(0, Math.round(seconds));
  if (elapsed < 60) {
    return `${elapsed} s`;
  }
  const minutes = Math.floor(elapsed / 60);
  const remainingSeconds = elapsed % 60;
  if (minutes < 60) {
    return `${minutes} min ${remainingSeconds} s`;
  }
  const hours = Math.floor(minutes / 60);
  return `${hours} h ${minutes % 60} min`;
}
